<div class="p-5 sm:p-6 w-full max-w-full box-border select-none overflow-x-hidden">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-3">
    <div class="h-10 w-10 shrink-0 rounded-full bg-emerald-100 flex items-center justify-center text-primary">
      <svg class="h-5 w-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    </div>
    <div class="min-w-0 flex-1">
      <h2 class="text-base sm:text-lg font-bold text-slate-900 leading-tight truncate">
        {{ feedbackService.feedback?.title || 'Required Feedback' }}
      </h2>
      <p class="text-xs text-slate-500 mt-0.5">
        Please complete this feedback to proceed with your journey.
      </p>
    </div>
  </div>

  <!-- Loading State -->
  @if (loading) {
    <div class="flex flex-col items-center justify-center py-10 gap-3">
      <div class="h-8 w-8 shrink-0 animate-spin rounded-full border-solid border-4 border-slate-200 border-t-primary"></div>
      <p class="text-xs text-slate-500 font-medium">Loading feedback questions...</p>
    </div>
  } @else {
    <!-- Form Fields Reusing LearningFeedbackFieldsComponent -->
    <div class="dialog-scroll-body max-h-[60vh] pr-2">
      <app-learning-feedback-fields [feedbackService]="feedbackService" [showTitle]="false" />
    </div>

    @if (errorMessage) {
      <div class="mt-2.5 rounded-lg bg-red-50 p-2.5 text-xs text-red-700 font-medium border border-red-200">
        {{ errorMessage }}
      </div>
    }

    <!-- Submit Button (No cancel button since feedback is mandatory) -->
    <div class="mt-4 flex justify-end">
      <button
        type="button"
        class="sx-btn-primary w-full sm:w-auto px-6 py-2.5 text-sm font-semibold rounded-xl cursor-pointer"
        [disabled]="submitting"
        (click)="submit()"
      >
        @if (submitting) {
          <span class="inline-flex items-center gap-2">
            <span class="h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-solid border-white border-t-transparent"></span>
            Submitting...
          </span>
        } @else {
          <span>Submit Feedback</span>
        }
      </button>
    </div>
  }
</div>
